<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row my-profile-form">



  <div class="columninvoice margin-top-17px">
    <div class="card height-100vh ">
      <div class="card-header wh-header  padding-bottom-0px padding-left-0px padding-right-0px padding-t-6px ">
        <div class="row border-bottom padding-bottom-5px margin-left-0px margin-right-0px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-10 padding-right-0px">
                <label class="margin-bottom-0px margin-left-5px">Edit Purchase Order</label>
              </div>
            </div>
          </div>


          <div class="col-md-6 float-right">
            <div class="row">              
              <div class="offset-md-4 col-md-8 padding-left-0px">
                <button type="button" class="btn btn-secondary float-right  font-size-13px margin-left-5px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                        (click)="Cancel()">Back
                </button>
                <div class="display-inline" *canUserAccess="['HL_ER_ApprovePO']">
                  <button type="button"
                          class="btn btn-secondary float-right font-size-13px margin-right-3px btn-raised button-Schedule actions-btn-prime actions-btn-prime3"
                          (click)="Approve()">
                    Approve
                  </button>
                </div>
                <div>
                  <button class="btn actions-btn-prime margin-right-8px font-size-13px background-transparent-button color-new-button border-color-new float-right"
                          (click)="SaveData()" *ngIf='isvisible'>
                    Submit <i class="far fa-save nav-link-hand font-size-14 "></i>
                  </button>
                </div>
              </div>
            </div>
            
          </div>

        </div>
        <div class="row border-top border-bottom bk-color-light margin-left-0px margin-right-0px">

        </div>
      </div>
      <div class="card-body  padding-bottom-0px padding-left-0px padding-right-0px padding-top-0px margin-left-10px">




        <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-80pe">
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleone">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Order Details
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExampleone">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-md-6">
                              
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Code </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px ">
                                        {{CurrentPurchaseOrderHeaderDetailsController.SupplierCode}}
                                      </label>
                                    </div>
                                    <div class="col-md-2">
                                      <button type="button"
                                              class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                              (click)="SelectVendor()">
                                        <i class="fas fa-ellipsis-h"></i>
                                      </button>
                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">                                      
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Name </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px">
                                        {{CurrentPurchaseOrderHeaderDetailsController.SupplierName}}
                                      </label>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Contact Person </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <label class="font-weight-normal font-size-12px margin-bottom-0px">
                                        {{CurrentPurchaseOrderHeaderDetailsController.VendorContactPerson}}
                                      </label>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Vendor Document Ref </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <textarea class="form-control3 size-2 width-inherit"
                                                rows="2" placeholder="Vendor Document Ref"
                                                name="CurrentPurchaseOrderHeaderDetailsController.RefNo"
                                                [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.RefNo"></textarea>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Order Code </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <label class="margin-bottom-0px form-control">
                                        {{CurrentPurchaseOrderHeaderDetailsController.PurchaseOrderCode}}
                                      </label>
                                    </div>

                                  </div>

                                </div>
                              </div>

                            </div>
                            <div class="col-md-6">


                              <!--<div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right padding-left-0px">
                                      <label for="firstName" class="margin-bottom-0px margin-top-5px">Status</label>
                                    </div>
                                    <div class="col-md-5">
                                      <label class="margin-bottom-0px form-control">
                                        {{CurrentPurchaseOrderHeaderDetailsController.OrderStatus}}
                                      </label>
                                    </div>

                                  </div>

                                </div>
                              </div>-->                              
                              <div hidden class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Posting Date</label>
                                    </div>

                                    <div class="col-md-5">
                                      <!--<div class="date-form" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                        <input class="form-control form-control-patient" placeholder="Posting Date"
                                               name="dps" [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.OrderDate"
                                               ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                        <a (click)="d1fe.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                        </a>
                                      </div>-->
                                      <label class="form-control margin-bottom-0px">
                                        {{CurrentPurchaseOrderHeaderDetailsController.OrderDate | date:'MMM-dd-yyyy'}}
                                      </label>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div hidden class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Delivery Date</label>
                                    </div>
                                    <div class="col-md-5">
                                      <!--<div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Delivery Date"
                                               name="dp" [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.DeliveryDate"
                                               ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1f="ngbDatepicker" #DOBf="ngModel">
                                        <a (click)="d1f.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                                        </a>
                                      </div>-->
                                      <label class="form-control margin-bottom-0px">
                                        {{CurrentPurchaseOrderHeaderDetailsController.DeliveryDate | date:'MMM-dd-yyyy'}}
                                      </label>
                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Ship To Location </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <CustomDataByRequestType RequestedType="AccessibleStores" FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}}
                                                               class="form-group margin-bottom-0px" SelectedValue="ShipToLocationname"
                                                               [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.ShipToLocationCode"
                                                               (keyChange)="onAssignedShipToLocationname($event)"
                                                               name="ShipToLocationname" #sign2="ngModel">
                                      </CustomDataByRequestType>
                                    </div>                                    
                                  </div>

                                </div>
                              </div>
                              <div class="row" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="firstName" class="margin-bottom-0px margin-top-3px">Pay Against </label>
                                    </div>:
                                    <div class="col-md-5">
                                      <CodeTypeValue CodeType="PAYAG"
                                                     id="CurrentPurchaseOrderHeaderDetailsController.PayAgainst"
                                                     [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.PayAgainst"
                                                     SelectedValue="CurrentPurchaseOrderHeaderDetailsController.PayAgainst"
                                                     name="CurrentPurchaseOrderHeaderDetailsController.PayAgainst">
                                      </CodeTypeValue>
                                    </div>

                                  </div>

                                </div>
                              </div>
                              <div class="row padding-top-3px" *ngIf="CurrentPurchaseOrderHeaderDetailsController">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                  <div class="row">
                                    <div class="col-md-4 text-align-right">
                                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Payment Term in Days</label>
                                    </div>

                                    <div class="col-md-7 padding-right-0px">
                                      <textarea class="form-control3 size-2 width-inherit"
                                                rows="2" placeholder="Payment Term in Days"
                                                name="CurrentPurchaseOrderHeaderDetailsController.PaymentTermsinDays"
                                                [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.PaymentTermsinDays"></textarea>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleFou">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFou">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFou" aria-expanded="true" aria-controls="collapseFou">
                                Line Items
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseFou" class="collapse show" aria-labelledby="headingFou" data-parent="#accordionExampleFou">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row padding-top-3px">
                            <div class="col-md-12 padding-left-0px padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-10px table-fixed"
                                         cols="auto,2*,*,*,*,*,*,*">

                                    <thead class="">
                                      <tr>

                                        <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                                          #
                                        </th>


                                        <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-10px">
                                          Item Description

                                        </th>
                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Ord Qty
                                        </th>
                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Bonus Qty
                                        </th>
                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Total Qty
                                        </th>
                                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                          Unit Price
                                        </th>
                                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                          Item Total
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Disc %
                                        </th>
                                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px th-sticky">
                                          Disc
                                        </th>
                                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                          Tax %
                                        </th>
                                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                          Tax
                                        </th>

                                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                                          Item Net
                                        </th>
                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Uom
                                        </th>
                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Pack
                                        </th>

                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          Pur Price
                                        </th>

                                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                                          MRP
                                        </th>

                                        <th class="padding-top-4px padding-bottom-4px th-sticky">

                                        </th>

                                      </tr>
                                    </thead>

                                    <tbody class="table-body" *ngIf="PurchaseOrderData.Items">
                                      <tr *ngFor="let l of PurchaseOrderData.Items">


                                        <td class="td-padding-tb">
                                          {{l.ItemCode}}
                                        </td>
                                        <td class=" td-padding-tb">
                                          <div>
                                            {{l.ItemDescription}}
                                          </div>

                                        </td>

                                        <td class="td-padding-tb">
                                          {{l.Quantity}}
                                        </td>
                                        <td class="td-padding-tb">
                                          {{l.BonusQuantity}}
                                        </td>
                                        <td class="td-padding-tb">
                                          {{l.TotalOrderQuantity}}
                                        </td>
                                        <td class="text-align-center td-padding-tb padding-right-0px">
                                          {{(l.PurchasePrice / l.Pack) | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{ (l.Quantity * l.PurchasePrice) - l.Discount | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.DiscountPercent | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.Discount | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.TaxPercent | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px">
                                          {{l.Tax | number:'1.0-2'}}
                                        </td>

                                        <td class="td-padding-tb padding-right-0px">
                                          {{ ((l.Quantity * l.PurchasePrice) - l.Discount)  + l.Tax | number:'1.0-2'}}
                                        </td>
                                        <td class="td-padding-tb text-align-center max-width-10pe">
                                          <a class="margin-bottom-0px color-blue">{{l.UomName}}</a>
                                        </td>
                                        <td class="td-padding-tb text-align-center max-width-10pe">
                                          {{l.Pack}}
                                        </td>
                                        <td class="td-padding-tb padding-right-0px padding-top-0px ">
                                          {{l.PurchasePrice | number:'1.0-2'}}
                                        </td>
                                        <td class="text-align-center td-padding-tb padding-right-0px">{{l.Mrp | number:'1.0-2'}}</td>

                                        <td class=" td-padding-tb text-align-center">
                                          <a (click)="EditItems(PurchaseOrderData, l)" class="nav-link-hand font-size-16px color-secondary margin-right-10px" title="Edit">
                                            <i class="fas fa-pencil-alt"></i>
                                          </a>
                                          <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                                        </td>
                                      </tr>
                                    </tbody>



                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleTwo">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Summary Totals
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExampleTwo">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row border-top opbill-receipthead-bgclr border-bottom bk-color-light margin-left-0px margin-right-0px">
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Total Before Tax</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseOrderData.TotalBeforeTax | number:'1.0-2'}}</h4></div>
                            </div>
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Tax</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseOrderData.Tax | number:'1.0-2'}}</h4></div>
                            </div>
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Grand Total</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseOrderData.GrandTotal | number:'1.0-2'}}</h4></div>
                            </div>
                            <div class="col-md-2 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="height-18px"><label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">Discount Amount</label></div>
                              <div><h4 class="margin-bottom-0px font-size-16px color-Assign margin-top-5px">{{PurchaseOrderData.DiscountAmount | number:'1.0-2'}}</h4></div>
                            </div>

                            <!--<div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="row">
                                <div class="col-md-5 margin-top-9px padding-right-0px margin-left-10px padding-left-9px">
                                  <label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">
                                    Tax
                                  </label>
                                </div>

                                <div class="col-md-5 padding-right-0px margin-top-4px">
                                  <input type="text" class="form-control" placeholder="Tax"
                                         id="PurchaseOrderData.Tax"
                                         [(ngModel)]="PurchaseOrderData.Tax"
                                         name="PurchaseOrderData.Tax" #Tax="ngModel"
                                         maxlength="5" pattern="^[\0-9,._\-?]*$">
                                </div>
                              </div>
                            </div>

                            <div class="col-md-3 border-right-1px padding-right-0px padding-left-0px text-align-center">
                              <div class="row">
                                <div class="col-md-5 margin-top-9px padding-right-0px margin-left-10px padding-left-9px">
                                  <label class="label-color-consultant font-size-12px font-weight-bold margin-bottom-0px data-color-new">
                                    Grand Total
                                  </label>
                                </div>

                                <div class="col-md-5 padding-right-0px margin-top-4px">
                                  <input type="text" class="form-control" placeholder="Grand Total"
                                         id="PurchaseOrderData.GrandTotal"
                                         [(ngModel)]="PurchaseOrderData.GrandTotal"
                                         name="PurchaseOrderData.GrandTotal" #GrandTotal="ngModel"
                                         maxlength="5" pattern="^[\0-9,._\-?]*$">
                                </div>
                              </div>
                            </div>-->
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleT">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingT">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseT" aria-expanded="true" aria-controls="collapseT">
                                Terms & Conditions
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseT" class="collapse show" aria-labelledby="headingT" data-parent="#accordionExampleT">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row padding-top-3px">
                            <div class="col-md-11 padding-right-0px margin-left-10px">
                              <textarea class="form-control3 size-2 width-inherit background-lightblue"
                                        rows="2" placeholder="Terms & Conditions"
                                        name="CurrentPurchaseOrderHeaderDetailsController.TermsAndConditions"
                                        [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.TermsAndConditions"></textarea>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row margin-left-2px">
            <div class="col-md-12  padding-right-0px padding-left-9px">
              <div id="items">
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExampleThr">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThr">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThr" aria-expanded="true" aria-controls="collapseThr">
                                Remarks
                              </button>
                            </h5>
                          </div>

                        </div>


                      </div>

                      <div id="collapseThr" class="collapse show" aria-labelledby="headingThr" data-parent="#accordionExampleThr">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row padding-top-3px">
                            <div class="col-md-11 padding-right-0px margin-left-10px">
                              <textarea class="form-control3 size-2 width-inherit background-lightblue"
                                        rows="2" placeholder="Remarks"
                                        name="CurrentPurchaseOrderHeaderDetailsController.Remarks"
                                        [(ngModel)]="CurrentPurchaseOrderHeaderDetailsController.Remarks"></textarea>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>


        </div>
      </div>

    </div>
  </div>

</div>
